module.exports = __webpack_public_path__ + "img/DSCN2590.8702fea7.jpg";